import AddressSpace from '@/models/list/address-space';
import locationPlaceholder from '@/assets/location.jpg';

export default class Address {
  constructor(address) {
    this.id = address.id;
    this.address = address.address;
    this.lat = address.lat;
    this.lon = address.lon;

    this.address_space = address.address_space ? new AddressSpace(address.address_space) : null;

    this.spaces = [];
  }

  async getSpaces() {
    const { AddressesManager } = await import('@/models/managers/addresses');
    const params = {
      expand: 'images',
      'search[address_id]': this.id,
    };
    const response = await AddressesManager.spaces.index({ params });
    this.spaces = response.items;
    return response;
  }

  getImage() {
    const spaceWithImages = this.spaces.find((space) => space?.images?.length);
    const [firstImage] = spaceWithImages?.images || [];
    return firstImage?.thumb || firstImage?.src || locationPlaceholder;
  }
}
